import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { darkTheme, lightTheme } from '../theme/Theme'
import { TabletSize } from '../responsive/TabletSize'
import { MobileSize } from '../responsive/MobileSize'
import { ScoialIconList } from '../data/ScoialIconList'

const IconsGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    position: fixed;
    bottom: 0px;
    left: 20px;
    ${TabletSize({ top: "30%" })};
    ${MobileSize({ left: "10px" })};
`

const IconBox = styled.div``

const LineBar = styled.span`
    width: 5px;
    height: 100px;
    background-color: ${props => props.click ? props.theme.body : props.theme.text};
    ${TabletSize({ display: "none" })};
`

const SocialIcons = ({ click,theme }) => {

    const themes = theme === "dark" ? darkTheme : lightTheme; 
    
    const iconColor = click ? themes.body : themes.text;

  return (
    <IconsGroup>
        {ScoialIconList.map((item) => (
           <IconBox>
            <NavLink  to={{ pathname: `${item.link}` }} target="_blank">
                <item.icon width={30} height={30} fill={iconColor} />
            </NavLink>
            </IconBox>
        ))}
        <LineBar click={click}/>
    </IconsGroup>
  )
}

export default SocialIcons